"use strict";

exports.__esModule = true;
exports.ServicesPreferencesModalStep = exports.OptionalFormatterKey = exports.FormatterKey = exports.AsyncComponentDataStatus = void 0;
let AsyncComponentDataStatus = /*#__PURE__*/function (AsyncComponentDataStatus) {
  AsyncComponentDataStatus["LOADING"] = "loading";
  AsyncComponentDataStatus["ERROR"] = "error";
  AsyncComponentDataStatus["IDLE"] = "idle";
  return AsyncComponentDataStatus;
}({});
exports.AsyncComponentDataStatus = AsyncComponentDataStatus;
let FormatterKey = /*#__PURE__*/function (FormatterKey) {
  FormatterKey["DELETE_SERVICE_BUTTON_ARIA_LABEL"] = "DELETE_SERVICE_BUTTON_ARIA_LABEL";
  FormatterKey["EDIT_SERVICE_BUTTON_ARIA_LABEL"] = "EDIT_SERVICE_BUTTON_ARIA_LABEL";
  FormatterKey["HOUR_UNIT"] = "HOUR_UNIT";
  FormatterKey["MINUTE_UNIT"] = "MINUTE_UNIT";
  FormatterKey["NEXT_BUTTON"] = "NEXT_BUTTON";
  FormatterKey["BACK_BUTTON"] = "BACK_BUTTON";
  FormatterKey["SUBMIT_BUTTON"] = "SUBMIT_BUTTON";
  FormatterKey["SELECT_STAFF_LABEL"] = "SELECT_STAFF_LABEL";
  FormatterKey["SELECT_LOCATION_LABEL"] = "SELECT_LOCATION_LABEL";
  FormatterKey["ADD_ANOTHER_SERVICE_BUTTON"] = "ADD_ANOTHER_SERVICE_BUTTON";
  FormatterKey["ADD_ANOTHER_SERVICE_DESCRIPTION"] = "ADD_ANOTHER_SERVICE_DESCRIPTION";
  FormatterKey["PRICE_RANGE"] = "PRICE_RANGE";
  FormatterKey["NUMBER_OF_SERVICES"] = "NUMBER_OF_SERVICES";
  FormatterKey["SELECTED_STAFF"] = "SELECTED_STAFF";
  FormatterKey["CONFIRMATION_STEP_TITLE"] = "CONFIRMATION_STEP_TITLE";
  FormatterKey["CONFIRMATION_STEP_TEXT"] = "CONFIRMATION_STEP_TEXT";
  FormatterKey["CONFIRMATION_STEP_LEAVE_BUTTON"] = "CONFIRMATION_STEP_LEAVE_BUTTON";
  FormatterKey["CONFIRMATION_STEP_STAY_BUTTON"] = "CONFIRMATION_STEP_STAY_BUTTON";
  FormatterKey["LOADING_TEXT"] = "SELECT_STAFF_PLACEHOLDER";
  FormatterKey["SELECT_ANY_STAFF"] = "SELECT_ANY_STAFF";
  FormatterKey["SUMMARY_ANY_STAFF"] = "SUMMARY_ANY_STAFF";
  FormatterKey["SELECT_CUSTOM_PREFERENCE_PLACEHOLDER"] = "SELECT_CUSTOM_PREFERENCE_PLACEHOLDER";
  FormatterKey["SELECT_CUSTOM_PREFERENCE_ERROR"] = "SELECT_CUSTOM_PREFERENCE_ERROR";
  FormatterKey["SERVICE_PREFERENCES"] = "SERVICE_PREFERENCES";
  FormatterKey["CLOSE_MODAL_BUTTON_ARIA_LABEL"] = "CLOSE_MODAL_BUTTON_ARIA_LABEL";
  FormatterKey["CLOSE_CONFIRMATION_MODAL_BUTTON_ARIA_LABEL"] = "CLOSE_CONFIRMATION_MODAL_BUTTON_ARIA_LABEL";
  FormatterKey["SERVICE_PREFERENCES_TITLE"] = "SERVICE_PREFERENCES_TITLE";
  FormatterKey["ERROR_FETCHING_DATA"] = "ERROR_FETCHING_DATA";
  FormatterKey["PREFERENCES_STEP_TITLE"] = "PREFERENCES_STEP_TITLE";
  FormatterKey["BASKET_STEP_TITLE"] = "BASKET_STEP_TITLE";
  FormatterKey["SERVICE_SELECTION_STEP_TITLE"] = "SERVICE_SELECTION_STEP_TITLE";
  FormatterKey["PAYMENT_PRICING_PLAN_DESCRIPTION"] = "PAYMENT_PRICING_PLAN_DESCRIPTION";
  FormatterKey["CAPITALIZED_PAYMENT_PRICING_PLAN_DESCRIPTION"] = "CAPITALIZED_PAYMENT_PRICING_PLAN_DESCRIPTION";
  FormatterKey["PAYMENTS_SEPARATOR"] = "PAYMENTS_SEPARATOR";
  return FormatterKey;
}({});
exports.FormatterKey = FormatterKey;
let OptionalFormatterKey = /*#__PURE__*/function (OptionalFormatterKey) {
  OptionalFormatterKey["CONFIRMATION_STEP_SUBTEXT"] = "CONFIRMATION_STEP_SUBTEXT";
  return OptionalFormatterKey;
}({});
exports.OptionalFormatterKey = OptionalFormatterKey;
let ServicesPreferencesModalStep = /*#__PURE__*/function (ServicesPreferencesModalStep) {
  ServicesPreferencesModalStep["PREFERENCES"] = "PREFERENCES";
  ServicesPreferencesModalStep["BASKET"] = "BASKET";
  ServicesPreferencesModalStep["SERVICE_SELECTION"] = "SERVICE_SELECTION";
  return ServicesPreferencesModalStep;
}({});
exports.ServicesPreferencesModalStep = ServicesPreferencesModalStep;
//# sourceMappingURL=types.js.map